export * from "./components";
export * from "./integration-modal";
import { registerProofIntegrationModal } from "./integration-modal";
registerProofIntegrationModal();
import {
  registerProofForm,
  registerProofAuthoring,
  registerProofConfiguration,
  registerProofProjectExport,
  registerProofDocumentImport,
  registerProofRevisionReview,
  registerProofFontLibrary,
  registerProofAssetLibrary,
  registerProofBulkGeneration,
  registerProofFormConfiguration,
  registerProofEsmProject,
} from "./components";
registerProofForm();
registerProofAuthoring();
registerProofConfiguration();
registerProofProjectExport();
registerProofDocumentImport();
registerProofRevisionReview();
registerProofFontLibrary();
registerProofAssetLibrary();
registerProofBulkGeneration();
registerProofFormConfiguration();
registerProofEsmProject();
